import * as React from 'react';
import ReactDOM from 'react-dom';
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Text
} from '@chakra-ui/react';

interface IProps {
  id?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  show: boolean;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  maxWidthPx?: number;
  hideHeader?: boolean;
  hideFooter?: boolean;
  backgroundColor?: string;
  textColor?: string;
  headerFontSize?: number;
  headerMargin?: number;
  paddingTop?: number;
  withoutPadding?: boolean;
  canClose?: boolean;
  onClose?: () => void;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | string;
  scrollBehaviour?: 'inside' | 'outside';
  closeOnOverlayClick?: boolean;
  modalBodyProps?: React.ComponentProps<typeof ModalBody>;
  modalContentProps?: React.ComponentProps<typeof ModalContent>;
  modalOverlayProps?: React.ComponentProps<typeof ModalOverlay>;
  modalProps?: React.ComponentProps<typeof ChakraModal>;
}

const Modal = (props: IProps) => {
  const {
    id = 'enroly',
    show = false,
    title = '',
    children,
    footer,
    size = 'xl',
    description,
    canClose = true,
    onClose = () => {},
    hideHeader = false,
    hideFooter = false,
    closeOnOverlayClick = false,
    scrollBehaviour = 'outside'
  } = props;

  return (
    <ChakraModal
      size={size}
      id={`${id}-modal`}
      data-selector={`${id}-modal`}
      isOpen={!!show}
      onClose={onClose}
      scrollBehavior={scrollBehaviour}
      closeOnOverlayClick={closeOnOverlayClick}
      {...props?.modalProps}
    >
      <ModalOverlay {...props?.modalOverlayProps} />

      <ModalContent {...props?.modalContentProps}>
        {!hideHeader ? <ModalHeader data-selector={`${id}-modal-header`}>{title}</ModalHeader> : null}

        {canClose ? <ModalCloseButton data-selector="close-icon" tabIndex={0} /> : null}

        {children || description ? (
          <ModalBody pb={hideFooter ? 6 : 2} {...props?.modalBodyProps}>
            {description ? (
              <Text color="muted" data-selector={`${id}-modal-header-description`}>
                {description}
              </Text>
            ) : null}

            {children}
          </ModalBody>
        ) : null}

        {!hideFooter ? <ModalFooter>{footer}</ModalFooter> : null}
      </ModalContent>
    </ChakraModal>
  );
};

function ModalPortal(props): React.ReactPortal {
  return ReactDOM.createPortal(
    <Modal {...props} />,
    document.getElementById('modal') as HTMLElement
  ) as React.ReactPortal;
}

export default ModalPortal;

export { ModalColumns } from './ModalColumns';

export { Modal };
